export const detectLanguage = (pathname, setLang) => {
  let lang = ((pathname.split('/'))[1]).toUpperCase()
  setLang(lang === "ID" ? "ID" : "EN")
}